import { Box, Button, Container, Grid, Input, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Stack, Select, MenuItem, RadioGroup, FormControlLabel, TextField } from "@mui/material"
import Bottom from "../../Bottom";
import { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import $ from 'jquery';
import tabbg from "../../../assets/images/tab_01.png"
import useStressStore from "../../../store/stressStores";
import api from "../../../utils/api";

import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';
import reimg1 from "../../../assets/images/reimg1.png";
import reimg2 from "../../../assets/images/reimg2.png";
import reimg3 from "../../../assets/images/reimg3.png";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Alert from '@mui/material/Alert';
import { notifyApiError } from "../../../utils/apiError";

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

// 새로고침 이미지 변경
const ImgArr = [reimg1, reimg3,];
const randomIndex = Math.floor(Math.random() * ImgArr.length);
const reTopImg = ImgArr[randomIndex];


const StressAnswer = () => {

  const storeData: any = useStressStore();
  const navigate = useNavigate();
  const location = useLocation();

  // hra 항목 추가 요소
  const [hraQ4, setHraQ4] = useState<string | null>(null);
  const [relation, setRelation] = useState('');
  const [age, setAge] = useState('');
  const [disease, setDisease] = useState('');
  
  useEffect(() => {
    getQuestionsList();

    return () => {
      // storeData.clear();
    }
  }, [])

  useEffect(() => {

    genRowspan('category');

  }, [storeData.questionsList])

  function getQuestionsList() {
    // state 가 없으면(새로고침·직접 URL 접근) 어떤 설문인지 알 수 없다.
    // 방어 없이 location.state.survey_uid 를 읽으면 렌더 중 예외로 화면이 비어버린다.
    if (!location.state) return;

    let userId: any = localStorage.getItem('userID');

    api.get(`customer/api/v2/surveys/${location.state.survey_uid}/assigns/${location.state.assigned_uid}`, { headers: { 'userId': userId } })
      .then(res => {
        // console.log(res);
        // storeData.setQuestionsList(res.data.data);

        const tempList = [];
        for (let i = 0; i < res.data.data.info.length; i++) {
          const { category, question } = res.data.data.info[i];
          const tempObj: any = {};
          tempObj.category = category.name;
          tempObj.category_uid = category.uid;
          tempObj.category_number = category.number;

          tempObj.number = question.number;
          tempObj.title = question.title;
          tempObj.question_uid = question.uid;
          tempObj.type = question.type;

          tempObj.strongly_disagree = question.option.strongly_disagree;
          tempObj.disagree = question.option.disagree;
          tempObj.agree = question.option.agree;
          tempObj.strongly_agree = question.option.strongly_agree;

          tempList.push(tempObj);
        }

        storeData.setQuestionsList(tempList);
      })
      .catch(err => {
        console.log(err);
      });
  }

  // 카테고리 rowspan 함수
  const genRowspan = (className: string) => {
    const elements = Array.from(
      document.querySelectorAll(`.${className}`)
    ) as HTMLTableCellElement[];
    let lastCategory = "";
    let rowspan = 1;
    let firstElement: HTMLTableCellElement | null = null;

    elements.forEach((element) => {
      const text = element.textContent;

      if (text === lastCategory) {
        rowspan++;
        element.style.display = "none";
        if (firstElement) {
          firstElement.setAttribute("rowspan", rowspan.toString());
        }
      } else {
        lastCategory = text || "";
        rowspan = 1;
        firstElement = element;
        element.removeAttribute("rowspan");
        element.style.display = "";
      }
    });
  };

  // 설문 제출하기
  function handleSubmitSurvey() {
    let valueStatus = true;
    const answer = [];
    const dLen = storeData.questionsList.length;

    for (let i = 0; i < dLen; i++) {
      const d = storeData.questionsList[i];
      const input = $(`input[name="${d.question_uid}"]${d.type !== 'text' ? ':checked' : ''}`);
      const value = $(input).val();

      valueStatus &&= !!value;
      if (!!!value) {
        $(`#stress-${d.number}`).children('div').not('.category').addClass('focusing');
        $(`#stress-${d.number}`).focus();
      }
      answer[d.number - 1] = {question: {uid: d.question_uid}, answer: $(input).val()};
    }

// --------------------------
    // HRA 추가 문항 값 가져오기
    // --------------------------
    const q1 = $(`input[name="hra_q1"]:checked`).val();
    const q2 = $(`input[name="hra_q2"]:checked`).val();
    const q3 = $(`input[name="hra_q3"]:checked`).val();
    const q4 = $(`input[name="hra_q4"]:checked`).val();

    let hraValueStatus = true;

    // 기존 focusing 제거
    $(`#hra-1, #hra-2, #hra-3, #hra-4`).children('td').removeClass('focusing');

    if (!q1) {
      hraValueStatus = false;
      $(`#hra-1`).children('td').addClass('focusing');
    }

    if (!q2) {
      hraValueStatus = false;
      $(`#hra-2`).children('td').addClass('focusing');
    }

    if (!q3) {
      hraValueStatus = false;
      $(`#hra-3`).children('td').addClass('focusing');
    }

    if (!q4) {
      hraValueStatus = false;
      $(`#hra-4`).children('td').addClass('focusing');
    }

    // 4번이 그렇다(Y)일 때만 추가 입력 검사
    if (q4 === 'Y') {
      if (!relation || !String(relation).trim()) {
        hraValueStatus = false;
        alert('직계가족 관계를 선택해주세요.');
        return;
      }

      if (!age || !String(age).trim()) {
        hraValueStatus = false;
        alert('발병 연령을 입력해주세요.');
        return;
      }

      if (!disease || !String(disease).trim()) {
        hraValueStatus = false;
        alert('질환을 선택해주세요.');
        return;
      }
    }


    if (!valueStatus) {
      alert("문항에 대한 응답을 모두 선택해주세요.");
      return;
    }

    if (!hraValueStatus) {
      alert('뇌심혈관질환 문항에 대한 응답을 모두 선택해주세요.');
      return;
    }

    const requestBody = {
      family: {
        id: localStorage.getItem('ownerFamID')
      },
      QnAs: answer,
      year: new Date().getFullYear(),
      uid: location.state.assigned_uid,
      hra: {
        q1: q1,
        q2: q2,
        q3: q3,
        q4: q4,
        relation: q4 === 'Y' ? relation : null,
        age: q4 === 'Y' ? age : null,
        disease: q4 === 'Y' ? disease : null
      }
    };
    api.post(`customer/api/v2/surveys/assigns/${location.state.assigned_uid}`, requestBody)
        .then(res => {
          if (res.data.success === false) {
            alert(res.data.message);
            return;
          }
          alert('저장되었습니다.');
          navigate('/survey/stress');
        })
        .catch(err => {
          // 제출 실패를 알리지 않으면 사용자가 여러 번 눌러 중복 제출이 된다
          notifyApiError(err, '설문을 제출하지 못했습니다.');
        });
  }

  // 포커스
  function handleChange(e: any) {
    if (!$(e).is(":checked")) {
      $(e.target).closest('div.MuiGrid-container').removeClass('focusing');
      // $(e.target).closest('div.MuiGrid-container').siblings().removeClass('focusing');
    }
  }


  return (
    <Container sx={{ p: { xs: 0, md: 0 }, bgcolor: '#F6F6F6', pb: '60px !important', minHeight: '100vh', minWidth: 320 }}>
      <Box sx={{ bgcolor: '#FFEADF', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#ffeadf'} zIndex={999} maxWidth={'1200px'} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>
        <Grid container spacing={2} direction='row' sx={{ mt: 6, }}>
          <Grid container item xs sx={{ mx: 2, my: 5 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography className='topText' sx={{ fontSize: '2rem', color: '#FF7863', fontWeight: 900, textAlign: 'center'}}>
              직무스트레스
            </Typography>
            <Typography sx={{ fontSize: '1rem', color: '#EF8322', fontWeight: 500,  textAlign: 'center', mt: 2}} gutterBottom>
              한국인 직무 스트레스 측정도구<br/>(Korean Occupational Stress Scale: KOSS)
            </Typography>
          </Grid>
          
        </Grid>
      </Box>
      <Box sx={{p: 2, mt: -2}}>
        {
          storeData.questionsList && storeData.questionsList.map((item: any, idx: number) => {
                
            return (
              <>
              <Box key={idx} id={`stress-${item.number}`} sx={{}}>
                <Box className="category" sx={{width: '100%', textAlign: "center", bgcolor:'#e5e5e5', py: 1, mt: 5, }}>
                  <Typography sx={{fontSize: 14, fontWeight: 700}} >{item.category}</Typography>
                </Box>
                <Grid container sx={{bgcolor: '#fff', borderBottom:'1px solid rgb(204, 204, 204)', '&.focusing': {bgcolor: 'rgba(255, 152, 139, 0.05) !important'} }}>
                  <Grid item xs={12} sx={{p: 1}}>
                    <Box sx={{display:'flex', alignItems:'center'}}>
                      <Box sx={{ fontSize: 14, bgcolor: '#FF7863', px: .8, py: .5, minWidth: 15, borderRadius:1, color: '#fff', textAlign:'center'}}>{item.number}</Box>
                      <Box sx={{ fontSize: 14, ml: 1, wordBreak: "keep-all"}}>{item.title}</Box>
                    </Box>
                    <Box sx={{display:'flex',justifyContent:'space-between', pt: 1 ,width:'100%', boxSizing:'border-box',  '& p': {textAlign:'center', fontSize: 12, color: '#333', flex: '1 0 auto' }}}>
                      <Typography>
                        <label>
                          <input name={item.question_uid} type={item.type} value={item.strongly_disagree} onChange={handleChange} />
                          <Typography>전혀 그렇지 않다</Typography>
                        </label>
                      </Typography>
                      <Typography>
                        <label>
                          <input name={item.question_uid} type={item.type} value={item.disagree} onChange={handleChange} />
                          <Typography>그렇지 않다</Typography>
                        </label>
                      </Typography>
                      <Typography>
                        <label>
                          <input name={item.question_uid} type={item.type} value={item.agree} onChange={handleChange} />
                          <Typography>그렇다</Typography>
                        </label>
                      </Typography>
                      <Typography>
                        <label>
                          <input name={item.question_uid} type={item.type} value={item.strongly_agree} onChange={handleChange} />
                          <Typography>매우 그렇다</Typography>
                        </label>
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>


              {/* <TableRow>
                <TableCell className="category" colSpan={6}></TableCell>
              </TableRow>
              <TableRow >
                <TableCell rowSpan={3}></TableCell>
                <TableCell colSpan={4}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  
                  </TableCell>
                  <TableCell>
                  
                  </TableCell>
                  <TableCell>
                  
                  </TableCell>
                  <TableCell>
                  
                  </TableCell>
              </TableRow> */}
              </>
            )
          })
        }
      </Box>

      <Typography sx={{fontSize: 14, fontWeight: 700, textAlign: 'center'}} > 뇌심혈관질환 발병위험도 평가 </Typography>
      <Box sx={{p: 2, mt: -2}}>
      {
        <Table size="small" className="Cl_table hm_table" sx={{
          width: '100%',
          ml: 'auto',
          mr: 'auto',
          bgcolor: '#fff',
          borderRadius: 0,
          borderCollapse: 'collapse',
          border: '1px solid #cfcfcf',
          fontSize: 12,
          '& *': {
            fontSize: '12px !important',
          },
          '& .MuiTableCell-root': {
            border: '1px solid #cfcfcf',
            padding: '10px !important',
            fontSize: 12,
            color: '#222'
          }
        }}>
          <TableHead
              sx={{
                '& th': {
                  bgcolor: '#e7e7e7',
                  fontWeight: 700,
                  textAlign: 'center',
                  border: '1px solid #cfcfcf',
                  padding: '10px !important',
                  lineHeight: 1.2,
                  fontSize: 12
                }
              }}
          >
            <TableRow>
              <TableCell width={25}>No</TableCell>
              <TableCell>내용</TableCell>
              <TableCell width={55}>그렇다</TableCell>
              <TableCell width={55}>아니다</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow id="hra-1">
              <TableCell sx={{ textAlign: 'center' }}>1</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                현재 흡연 중이다.
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <input type="radio" name="hra_q1" value="Y" />
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <input type="radio" name="hra_q1" value="N" />
              </TableCell>
            </TableRow>

            <TableRow id="hra-2">
              <TableCell sx={{ textAlign: 'center' }}>2</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                1주일에 3일 이상의 신체활동을 한다.
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <input type="radio" name="hra_q2" value="Y" />
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <input type="radio" name="hra_q2" value="N" />
              </TableCell>
            </TableRow>

            <TableRow id="hra-3">
              <TableCell sx={{ textAlign: 'center' }}>3</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                1일 30분 이상의 신체활동을 한다.
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <input type="radio" name="hra_q3" value="Y" />
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <input type="radio" name="hra_q3" value="N" />
              </TableCell>
            </TableRow>

            <TableRow id="hra-4">
              <TableCell sx={{ textAlign: 'center' }}>4</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                직계가족의 심혈관질환 조기 발병(65세 이전)에 해당사항이 있다.
              </TableCell>

              <TableCell sx={{ textAlign: 'center' }}>
                <input
                    type="radio"
                    name="hra_q4"
                    value="Y"
                    onChange={(e) => setHraQ4(e.target.value)}
                />
              </TableCell>

              <TableCell sx={{ textAlign: 'center' }}>
                <input
                    type="radio"
                    name="hra_q4"
                    value="N"
                    onChange={(e) => setHraQ4(e.target.value)}
                />
              </TableCell>
            </TableRow>

            {hraQ4 === 'Y' && (
                <TableCell colSpan={4} sx={{ textAlign: 'center' }}>
                  <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 0.5,
                      }}
                  >
                    {/* 관계 선택 */}
                    <Select
                        size="small"
                        value={relation}
                        onChange={(e) => setRelation(e.target.value)}
                        sx={{ minWidth: 90 }}
                    >
                      <MenuItem value="직계가족">직계가족</MenuItem>
                      <MenuItem value="할아버지">할아버지</MenuItem>
                      <MenuItem value="할머니">할머니</MenuItem>
                      <MenuItem value="아버지">아버지</MenuItem>
                      <MenuItem value="어머니">어머니</MenuItem>
                      <MenuItem value="형제">형제</MenuItem>
                      <MenuItem value="자매">자매</MenuItem>
                      <MenuItem value="아들">아들</MenuItem>
                      <MenuItem value="딸">딸</MenuItem>
                    </Select>

                    <Typography sx={{ fontSize: 12, lineHeight: 1, mr:2, fontWeight: 'bold' }}>
                      (이)가
                    </Typography>

                    <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.3,
                        }}
                    >
                      <TextField
                          variant="outlined"
                          size="small"
                          value={age}
                          onChange={(e) => setAge(e.target.value)}
                          placeholder="ex) 50"
                          sx={{
                            width: 80,
                            '& .MuiInputBase-input': {
                              py: 0.8,
                              textAlign: 'center',
                              fontSize: 12,
                            },
                          }}
                      />
                      <Typography sx={{ fontSize: 12, lineHeight: 1, fontWeight: 'bold'}}>
                        세경
                      </Typography>
                    </Box>

                    <RadioGroup row value={disease} onChange={(e) => setDisease(e.target.value)}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                  ml: 1,
                                }}
                    >
                      <FormControlLabel
                          value="뇌졸중"
                          control={<Radio size="small" />}
                          label="뇌졸중"
                          sx={{
                            m: 0,
                            alignItems: 'center',
                            '& .MuiFormControlLabel-label': {
                              fontSize: 12,
                              lineHeight: 1,
                            },
                          }}
                      />
                      <FormControlLabel
                          value="협심증"
                          control={<Radio size="small" />}
                          label="협심증"
                          sx={{
                            m: 0,
                            alignItems: 'center',
                            '& .MuiFormControlLabel-label': {
                              fontSize: 12,
                              lineHeight: 1,
                            },
                          }}
                      />
                      <FormControlLabel
                          value="심근경색증"
                          control={<Radio size="small" />}
                          label="심근경색증"
                          sx={{
                            m: 0,
                            alignItems: 'center',
                            '& .MuiFormControlLabel-label': {
                              fontSize: 12,
                              lineHeight: 1,
                            },
                          }}
                      />
                    </RadioGroup>

                    <Typography sx={{ fontSize: 12, lineHeight: 1, ml: 1, fontWeight: 'bold'}}>
                      발병
                    </Typography>
                  </Box>
                </TableCell>
            )}
          </TableBody>
        </Table>
      }
      </Box>

      <Box sx={{ textAlign: 'center', p: 2, mb:5 }}>
        <Alert severity="error">제출 후에는 수정할 수 없습니다.</Alert>
        <Button variant="contained" onClick={handleSubmitSurvey} sx={{ mt: 3, background: '#EF8322', p:1, borderRadius: 20, width: '100%', '&:hover': { background: '#EF8322' } }}>제출하기</Button>
      </Box>

      <Bottom />
    </Container>
  )
}


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}
export default StressAnswer;